import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const TorqueConverterGuidePage = () => <DataDrivenGuidePage slug="guide-torque-calculator" />;

export default TorqueConverterGuidePage;
